/* unplugin-vue-components disabled */import script from "./PointList.vue?vue&type=script&setup=true&lang=js"
export * from "./PointList.vue?vue&type=script&setup=true&lang=js"

import "./PointList.vue?vue&type=style&index=0&id=3c8db202&lang=scss"

const __exports__ = script;

export default __exports__